import React from 'react';

import buildAndPostForm from '../../../common/utils/postForm';
import { Button as VendorButton } from '@check24/form';
import { LinkOutContainer, PrimaryAlternativeButtonStyle } from './StyledUndefinedContractsElements';
import HintContainer from './Hint';
import { TrackingClass } from '../../../Enums/TrackingClass';
import capitalizeFirstLetter from '../../../../common/js/utils/capitalizeFirstLetter';
import styled from 'styled-components';
import CTA_BORDER_RADIUS from '../../../../common/js/constants/ctaBorderRadius.constant';

type ContractsSubmitType = {
    jumpinUrl: string;
    product: any;
    provider: any;
    formDefinition: any;
};

type PrimaryButtonPropsType = {
    visible: boolean;
    label: string;
    onClick: () => void;
    infoText: string;
};

type LinkOutButtonPropsType = {
    disabled: boolean;
    visible: boolean;
    label: string;
    onClick: () => void;
};

const StyledVendorButtonMobilePrimary = styled(VendorButton.Mobile.Primary)`
    border-radius: ${CTA_BORDER_RADIUS};

    &:disabled {
        background-color: #949494;
    }
`;

const PrimarySubmitButton = (props: PrimaryButtonPropsType) => {
    const { visible, label, infoText, onClick } = props;

    if (!visible) {
        return null;
    }

    return (
        <>
            <PrimaryAlternativeButtonStyle
                className={TrackingClass.CHECK24_CANCELLATION_CTA}
                label={capitalizeFirstLetter(label)}
                onClick={onClick}
            />
            <HintContainer hintType={'warning'} infoTextProvider={infoText} />
        </>
    );
};

const LinkOutButton = (props: LinkOutButtonPropsType) => {
    const { visible, label, disabled, onClick } = props;

    if (!visible) {
        return null;
    }

    return (
        <LinkOutContainer>
            <StyledVendorButtonMobilePrimary
                className={TrackingClass.LINK_OUT_CTA}
                label={capitalizeFirstLetter(label)}
                onClick={onClick}
                disabled={disabled}
            />
        </LinkOutContainer>
    );
};

const ContractsSubmit = (props: ContractsSubmitType) => {
    const { jumpinUrl, product, provider } = props;
    const linkOutDisabled = !provider.provider_id;
    const submitVisible =
        !linkOutDisabled && !!jumpinUrl.length && !provider?.providerversion_cancellation_button_url?.length;
    const linkOutVisible = !submitVisible;

    const handleLinkOutButton = () => {
        window.open(provider.providerversion_cancellation_button_url, '_blank')?.focus();
    };

    const handleButtonClick = () => {
        const { productGroup, productId } = product;
        const { provider_id } = provider;

        buildAndPostForm(jumpinUrl, { leadId: 0, productGroup, productId, providerId: provider_id });

        // fetch(jumpinUrl, {
        //     method: 'POST',
        //     body: '',
        //     credentials: 'include',
        // })
    };

    return (
        <>
            <PrimarySubmitButton
                visible={submitVisible}
                label={'bei CHECK24 kündigen'}
                onClick={handleButtonClick}
                infoText={provider.hint as any}
            />
            <LinkOutButton
                disabled={linkOutDisabled}
                visible={linkOutVisible}
                label={'direkt beim Anbieter kündigen'}
                onClick={handleLinkOutButton}
            />
        </>
    );
};

export default ContractsSubmit;
